import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage, intlShape } from 'react-intl';
import * as constants from '@redbubble/design-system/react/constants';
import Button from '@redbubble/design-system/react/Button';
import Box from '@redbubble/design-system/react/Box';
import Modal, { ModalBody } from '@redbubble/design-system/react/Modal';
import Text from '@redbubble/design-system/react/Text';
import messages from './messages';
import styles from './SignUpModal.css';

const SignUpModal = ({
  trigger,
  imgUrl,
  intl,
  open,
  onCloseRequested,
  location
}) => {
  const isRootLocation =
    location && ['/', '/es', '/de', '/fr'].includes(location.pathname);
  const nextAction = isRootLocation ? '&next_action=/explore/for-you' : '';

  return (
    <Modal
      trigger={trigger}
      accessibleTitle={intl.formatMessage(messages.SignUpPromptTitle)}
      getApplicationNode={() => document.getElementById('root')}
      open={open}
      onCloseRequested={onCloseRequested}
    >
      <div
        className={styles.hero}
        style={{ backgroundImage: `url(${imgUrl})` }}
      />
      <ModalBody>
        <Text className={styles.alignCenter} block type="display3">
          {intl.formatMessage(messages.SignUpPromptTitle)}
        </Text>
        <Text className={styles.alignCenter} block>
          <FormattedMessage {...messages.SignUpPromptDescription} />
        </Text>
        <Box display="flex" flexDirection="column" alignItems="center">
          <Box marginTop={1}>
            <Button
              intent={constants.PRIMARY}
              strong
              size={constants.LARGE}
              href={`/signup?ref=explore-favorite${nextAction}`}
            >
              <FormattedMessage {...messages.SignUpLink} />
            </Button>
          </Box>
          <Box marginTop={1}>
            <Button
              size={constants.LARGE}
              href={`/auth/login?ref=explore-favorite${nextAction}`}
            >
              <FormattedMessage {...messages.LogInLink} />
            </Button>
          </Box>
        </Box>
      </ModalBody>
    </Modal>
  );
};

SignUpModal.propTypes = {
  trigger: PropTypes.func,
  imgUrl: PropTypes.string.isRequired,
  intl: intlShape.isRequired,
  open: PropTypes.bool,
  onCloseRequested: PropTypes.func
};

SignUpModal.defaultProps = {
  onCloseRequested: () => {}
};

export default SignUpModal;
